
// The following assumes development runs will use a user-api server running over
// localhost:8080 (default). It also assumes that in production, the /api route on the
// same host is serving user-api endpoints
export const USER_API_URL = process.env.REACT_APP_USER_API_URL || '';
export const REDIRECT_ROOT = process.env.REACT_APP_REDIRECT_ROOT || '';